import { render, staticRenderFns } from "./MatomoOverview.vue?vue&type=template&id=8ce4121a"
import script from "./MatomoOverview.vue?vue&type=script&lang=js"
export * from "./MatomoOverview.vue?vue&type=script&lang=js"
import style0 from "./MatomoOverview.vue?vue&type=style&index=0&id=8ce4121a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports